import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Experience = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7796)">
      <rect x="6" y="5" width="20.1636" height="1" fill="currentColor" />
      <path d="M26.1638 14.52C26.1638 14.9733 26.0438 15.38 25.8038 15.74C25.7105 15.8733 25.5438 16.06 25.3038 16.3C25.0638 16.5267 24.8705 16.6933 24.7238 16.8C24.3105 17.0933 23.8372 17.24 23.3038 17.24H19.7838V21.96H17.6838V10H23.3038C23.8372 10 24.3105 10.1467 24.7238 10.44C24.8572 10.5333 25.0438 10.7067 25.2838 10.96C25.5372 11.2133 25.7105 11.4067 25.8038 11.54C26.0438 11.9 26.1638 12.3067 26.1638 12.76V14.52ZM24.0638 14.5V12.78C24.0638 12.7133 24.0572 12.6667 24.0438 12.64C23.8172 12.24 23.6038 12.0267 23.4038 12H23.3038H19.7838V15.24H23.3038C23.3972 15.24 23.5238 15.1667 23.6838 15.02C23.8438 14.8733 23.9638 14.7267 24.0438 14.58C24.0572 14.5533 24.0638 14.5267 24.0638 14.5Z" fill="currentColor" />
      <path d="M15.7395 10L12.1195 15.84L15.9395 21.96H13.5995L10.9595 17.7L8.33951 21.96H5.99951L9.79951 15.84L6.19951 10H8.51951L10.9595 13.98L13.4195 10H15.7395Z" fill="currentColor" />
      <rect x="6" y="25.96" width="20.1636" height="1" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7796">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Experience'
);
